import { MutationOptions, useMutation } from '@tanstack/react-query';
import Cookies from 'js-cookie';

import { conciergeClient } from 'src/api/concierge';
import { appConfig } from 'src/app/app-config';
import { supabaseClient } from 'src/auth/supabase';

const ACCESS_TOKEN_KEY = appConfig.supabase.cookies.accessTokenKey as string;
const REFRESH_TOKEN_KEY = appConfig.supabase.cookies.refreshTokenKey as string;

export const useInitializeSupabase = (config?: MutationOptions<boolean, Error>) =>
    useMutation<boolean, Error>({
        ...config,
        mutationKey: ['auth', 'supabase', 'initialize'],
        mutationFn: async () => {
            const accessToken = Cookies.get(ACCESS_TOKEN_KEY);
            const refreshToken = Cookies.get(REFRESH_TOKEN_KEY);

            if (accessToken && refreshToken) {
                supabaseClient.auth.setSession({
                    access_token: accessToken,
                    refresh_token: refreshToken,
                });
            }

            const { data } = await supabaseClient.auth.getSession();
            const token = data.session?.access_token;

            if (!token) {
                return false;
            }

            conciergeClient.defaults.headers.common.Authorization = `Bearer ${token}`;
            return true;
        },
        cacheTime: Number.POSITIVE_INFINITY,
    });
